<ng-container *ngIf="visibleWCP==2">
  <ng-container *ngIf="wcpValidado">
    <div class="divIframe" *ngIf="urlCorrect">
      <form action="{{urlWebComProfile}}" method="post" id="RecDatos" target="frameTableau" >
      </form>
      <iframe name="frameTableau"></iframe>
    </div>
    <ng-container *ngIf="!urlCorrect">
      <div class="NO_FORALL" fxLayout="column" fxLayoutAlign="center center">
      </div>
    </ng-container>

  </ng-container>
</ng-container>
<ng-container *ngIf="visibleWCP==1">
  <div class="NO_FORALL" fxLayout="column" fxLayoutAlign="center center">
  <h1 class="h1 secondary-text"><p class="texto">Actualmente el perfil de empresa se encuentra desactivado</p></h1>
  </div>
</ng-container>
